import { render, staticRenderFns } from "./IncidentTemplateBranding.vue?vue&type=template&id=2cf7d70a&"
import script from "./IncidentTemplateBranding.vue?vue&type=script&lang=js&"
export * from "./IncidentTemplateBranding.vue?vue&type=script&lang=js&"
import style0 from "./IncidentTemplateBranding.vue?vue&type=style&index=0&id=2cf7d70a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QFile from 'quasar/src/components/file/QFile.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QColor from 'quasar/src/components/color/QColor.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QFile,QIcon,QInput,QBtn,QPopupProxy,QColor});
